export default "__VITE_ASSET__T6$_oOhl__"